import { intervalToDuration } from 'date-fns'

function minTwoDigits(number: number): string {
  return `${number < 10 ? '0' : ''}${number}`
}

export default function formatTime(timeSeconds: number): string {
  const duration = intervalToDuration({ start: 0, end: timeSeconds * 1000 })
  const hours = duration.hours
  const minutes = minTwoDigits(duration.minutes)
  const seconds = minTwoDigits(duration.seconds)

  if (hours > 0) {
    return `${hours}:${minutes}:${seconds}`
  }

  return `${minutes}:${seconds}`
}
